import { defaultOccupationCredentialData } from '../../../../backend/config/classifiers/defaults/DefaultOccupationCredentialData';
import { occupationCredentialDataSchema } from '../../../../backend/config/classifiers/types';
import { updateLicenseCheckLatestStatusByFilter } from '../../../../backend/features/credentialing-verification';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { featureEnabled } from '../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const occupationCredentialEntityName = 'occupationCredential';
const occupationCredentialColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineOccupationCredentialClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: occupationCredentialColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { search: [params.data.name, params.data.status].join(' ') });
            },
            onChangeSync: (context) => {
                context.invalidateAppState('occupationCredentials');
            },
            onScheduleChangedAsync: (context) => {
                if (featureEnabled(context, 'licenseCheck')) {
                    return true;
                }
                return false;
            },
            onChangedAsync: (context, params) => {
                if (params.action === 'update' && params.prevData.name !== params.data.name) {
                    updateLicenseCheckLatestStatusByFilter(context, {
                        column: 'credentialId',
                        op: '=',
                        value: params.id,
                    });
                }
            },
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultOccupationCredentialData,
        publicData: [
            {
                classifierName: 'occupationCredential',
                mapValueDetailed: (item) => ({ value: item.id, label: item.columns.name, form: item.data.form }),
            },
            {
                classifierName: 'occupationCredentialNames',
                mapValue: (row) => ({ value: row.columns.name, label: row.columns.name }),
            },
        ],
    }, occupationCredentialDataSchema);
}
